import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';

type Props = {
  isInstanceSelected: boolean;
  onLoginAs: () => void;
};

const LoginAsHeader = ({ isInstanceSelected, onLoginAs }: Props) => {
  return (
    <div className="flex items-center justify-between">
      <Button variant="primary" disabled={!isInstanceSelected} onClick={onLoginAs}>
        <Trans>Login As</Trans>
      </Button>
      <div className="flex items-center gap-2">
        <PendoPlaceholder />
        <InstantSearchInput />
      </div>
    </div>
  );
};

export default LoginAsHeader;
